import { mapActions, mapGetters } from "vuex";

/**
 * The ride's "general information" notes and who may add or edit them: the
 * author of a base ride, or a manager who is the ride's author, never on a
 * locked ride. Shared by every design's general info (RideGeneralInfo,
 * PosterGeneralInfo) so the rule lives in one place.
 *
 * Needs a `ride` prop.
 */
export const rideGeneralInfoMixin = {
  computed: {
    ...mapGetters(['allRide', 'compareToUserId', 'isUserManager', 'isRideLocked']),
    extraInformation() {
      return Array.isArray(this.ride.rideExtraInformation) ? this.ride.rideExtraInformation : [];
    },
    canEdit() {
      const ride = this.allRide && this.allRide.ride;
      return !!ride &&
        ((ride.is_based_ride && this.compareToUserId(ride.authorId)) ||
         (this.isUserManager && this.compareToUserId(ride.authorId))) &&
        !this.isRideLocked;
    },
  },
  methods: {
    ...mapActions(['openExtraInformationForRide']),
    editExtraInformation(rideExtraInformationId) {
      if (this.isRideLocked) {
        this.$store.dispatch("showModalWithParameters", {
          errorNumber: "uesr_is_not_authorize_to_edit_this_ride",
          type: 'textConverter'
        });
        return;
      }
      this.$store.dispatch('editExtraInformationForRide', {
        rideId: this.allRide.ride.id,
        extraInformationId: rideExtraInformationId
      });
    },
  },
};
